import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Salmon Street Sewer Pump Station Relocation</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          We’re extending the existing sewer network to facilitate the future
          relocation of the Salmon Street pump station. This will increase the
          capacity of the sewer network to cater for population growth in the
          area and future proof the sewerage.
        </p>
        <p>
          These works will be completed in 3 stages. Stage 1 works to construct
          a new sewer from the intersection of Turner Street and Salmon Street,
          along Caprice Avenue Port Melbourne have begun. Stage 1 works are
          underway and are expected to be completed by early 2026.
        </p>
        <p>
          Stage 2 and 3 will involve constructing a new pump station and
          decommissioning the old pump station and will begin after stage 1 is
          completed.
        </p>

        <p>
          For more information on the Salmon Street sewer pump station
          relocation click{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/upgrades/salmonst/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (orange)',
                action: '<a href> link',
                label: 'MORE INFO: Salmon Street Sewer Pump Station Relocation',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800403833">1800 403 833</a>{' '}
        </p>
      </div>
    </>
  );
};

export default Content;
